import clsx from 'clsx';
import Link from 'next/link';
import { ReactElement } from 'react';

export const BASE_URL = 'https://www.wphospital.org';

// Replacing all base links with the BASE_URL seemed unnecessary,
// so this function was created and `sed`ed into the codebase.

interface WPBaseLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  isInternal?: boolean;
}
export const WPBaseLink = ({
  href,
  className,
  isInternal,
  ...props
}: WPBaseLinkProps): ReactElement => {
  if (isInternal && href) {
    return <Link href={href} className={className} {...props} />;
  }
  // For javascript: URLs, render a button styled as a link for accessibility
  if (href?.startsWith('javascript')) {
    return (
      <button
        type={'button'}
        className={clsx(
          className,
          'nav-btn font-inherit cursor-pointer border-none bg-transparent p-0 text-left text-inherit',
        )}
        {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)}
      />
    );
  }
  if (/^https?:\/\//.test(href || '')) {
    return <a href={href} className={className} {...props} />;
  }

  return <a href={`${BASE_URL}${href}`} {...props} className={className} />;
};
